var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "judgmentForm",
      attrs: { inline: true, model: _vm.viewerJudgment, "label-width": "200px" }
    },
    [
      _c(
        "el-form-item",
        {
          staticClass: "compact-form-item",
          attrs: { label: _vm.gradeLabel() }
        },
        [_vm._v(_vm._s(_vm.application.grade))]
      ),
      _c("br"),
      _vm.application.grade_description
        ? _c(
            "el-form-item",
            {
              staticClass: "compact-form-item",
              attrs: { label: _vm.gradeDescriptionLabel() }
            },
            [_vm._v(_vm._s(_vm.application.grade_description))]
          )
        : _vm._e(),
      _vm.isReappraisal && _vm.workingApplication.overdue
        ? _c(
            "el-form-item",
            { attrs: { label: " " } },
            [
              _vm.isReappraisal && _vm.workingApplication.overdue
                ? _c("el-alert", {
                    staticStyle: {
                      border: "1px solid",
                      "background-color": "#fdf6ec"
                    },
                    attrs: {
                      closable: false,
                      type: "warning",
                      title: _vm.OVERDUE_MESSAGE,
                      "show-icon": ""
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("br"),
      _vm.isReappraisal
        ? _c(
            "el-form-item",
            { attrs: { label: "Κατηγορία αίτησης" } },
            [
              _vm.isReappraisal
                ? _c("el-switch", {
                    attrs: {
                      disabled: "disabled",
                      "active-text": "Νομικό ζήτημα",
                      "inactive-text": "Ακαδημαϊκό ζήτημα"
                    },
                    model: {
                      value: _vm.workingApplication.legalIssue,
                      callback: function($$v) {
                        _vm.$set(_vm.workingApplication, "legalIssue", $$v)
                      },
                      expression: "workingApplication.legalIssue"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.isReappraisal ? _c("br") : _vm._e(),
      _c(
        "el-form-item",
        { attrs: { label: "Εσωτερικό Σχόλιο" } },
        [
          _c("el-input", {
            staticClass: "biggest",
            attrs: {
              type: "textarea",
              autosize: { minRows: 4, maxRows: 10 },
              placeholder: "Εισάγετε κείμενο για τον Πρόεδρο"
            },
            on: { change: _vm.modifycomment },
            model: {
              value: _vm.viewerJudgment.comment,
              callback: function($$v) {
                _vm.$set(_vm.viewerJudgment, "comment", $$v)
              },
              expression: "viewerJudgment.comment"
            }
          })
        ],
        1
      ),
      _vm.fromConsultantSecOverdue
        ? _c(
            "el-form-item",
            { attrs: { label: "Εισήγηση Δ/ντή Αναγν/σης" } },
            [
              _c("el-input", {
                staticClass: "biggest",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "Εισάγετε την εισήγησή σας"
                },
                model: {
                  value: _vm.viewerJudgment.proposal,
                  callback: function($$v) {
                    _vm.$set(_vm.viewerJudgment, "proposal", $$v)
                  },
                  expression: "viewerJudgment.proposal"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("proposals"),
      _c("internalComments"),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "danger",
                round: "",
                disabled: false
              },
              on: {
                click: function($event) {
                  _vm.finalSave()
                }
              }
            },
            [_vm._v("Οριστική Υποβολή")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51e75f92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e75f92","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/ViewerJudgment.vue
// module id = null
// module chunks = 